<div class="notification-bell">
  <button
    type="button"
    class="action-button"
    pButton
    pRipple
    icon="pi pi-bell"
    [text]="true"
    pBadge
    [value]="unreadCount() > 0 ? unreadCount().toString() : ''"
    [badgeDisabled]="!hasUnread()"
    badgeClass="notification-badge"
    [attr.aria-label]="'notifications.title' | transloco"
    (click)="toggle($event)">
  </button>

  <p-popover #panel styleClass="notification-bell__panel" appendTo="body">
    <ng-template pTemplate="content">
      <div class="notification-bell__header">
        <span class="notification-bell__title">{{ 'notifications.title' | transloco }}</span>
        @if (hasUnread()) {
          <button
            type="button"
            pButton
            severity="secondary"
            [text]="true"
            size="small"
            [label]="'notifications.markAllAsRead' | transloco"
            (click)="onMarkAllAsRead()">
          </button>
        }
      </div>

      <div class="notification-bell__body">
        @if (loading() && notifications().length === 0) {
          <div class="notification-bell__loading">
            <p-progressSpinner styleClass="w-2rem h-2rem" />
          </div>
        } @else if (isEmpty()) {
          <div class="notification-bell__empty">
            <i class="pi pi-bell-slash"></i>
            <p>{{ 'notifications.empty' | transloco }}</p>
          </div>
        } @else {
          @for (n of notifications(); track n.id) {
            <app-notification-item
              [notification]="n"
              [compact]="true"
              (clicked)="onItemClicked($event)"
              (read)="onItemRead($event)" />
          }
        }
      </div>

      <div class="notification-bell__footer">
        <button
          type="button"
          pButton
          [text]="true"
          severity="secondary"
          icon="pi pi-list"
          [label]="'notifications.viewAll' | transloco"
          (click)="onViewAll()">
        </button>
      </div>
    </ng-template>
  </p-popover>
</div>
